import NewPolicyJSC from '@/schema/NewPolicyJSC';
import PolicyJSC from '@/schema/PolicyJSC';
import { IRequestWrap } from '@/server/IServer';
import { TReqConfigValidated } from '@/services/JSCService';
import { joinURL } from '@/utils/functions/joinURL';
import { defaultTo } from 'ramda';

import { SunnyRequestBuilder } from '../Common/SunnyRequestBuilder';
import { INewPolicyRequestParams } from './interfaces/INewPolicyRequestParams';
import { IPolicyRequestParams } from './interfaces/IPolicyRequestParams';

const adjustPolicyRequest = (query) =>
  ({
    service: {
      url: '/pf/api/service',
      query,
    },
    privacy_short_member_required: {
      url: '/api/policy/pc/v1/policies/1/sub-templates/privacy-short-member-required/html',
      query: {
        'include-row-numbers': 1,
      },
    },
    privacy_short_member_optional: {
      url: '/api/policy/pc/v1/policies/1/sub-templates/privacy-short-member-optional/html',
      query: {
        'include-row-numbers': 1,
      },
    },
    location: {
      url: '/api/policy/pc/v1/policies/2/html',
      query: {},
    },
    privacy_short_member_milk_required: {
      url: '/policy',
      query,
    },
    privacy_short_thirdparty_milk_required: {
      url: '/policy',
      query,
    },
  }[query.t] || { url: '', query });

export class PolicyClientRequestBuilder extends SunnyRequestBuilder {
  createPolicyQuery(reqParams: IPolicyRequestParams): TReqConfigValidated {
    return this.validate(PolicyJSC, reqParams).map((params) => this.makeConfig('GET', '/policy', params));
  }

  createNewPolicyQuery(reqParams: INewPolicyRequestParams): TReqConfigValidated {
    return this.validate(NewPolicyJSC, reqParams).map((params) => this.makeConfig('GET', '/pf/coin/service', params));
  }
}

export class PolicyRequestBuilder extends PolicyClientRequestBuilder {
  protected makeHeaders = defaultTo({});

  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.Policy;
  }

  createPolicyQuery(reqParams: IPolicyRequestParams): TReqConfigValidated {
    // [SEC-14153] redirect 되지 않는 현상으로 인한 임시조치
    // return this.validate(PolicyJSC, reqParams).map((params) => this.makeConfig('GET', '', params));
    const { url, query } = adjustPolicyRequest(reqParams.query);
    return this.validate(PolicyJSC, { ...reqParams, query }).map((params) => this.makeConfig('GET', url, params));
  }

  protected getAPIEndpoint(path: string): string {
    return joinURL(this.baseURI.href(), path);
  }
}

export class PolicyIORequestBuilder extends PolicyRequestBuilder {
  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.PolicyIO;
  }
}
